import React, { useEffect, useState } from 'react';
import { Input, InputNumber } from 'antd';
import PropTypes from 'prop-types';
import { isEmpty, isNaN, isNil } from 'lodash';

import { currencyFormatter, numberInputFormatter, numberInputParser, percentageFormatter } from 'utils';
import { Label, InfoMessage } from 'components';
import TextField from 'components/textfield2';
import { useSelector } from 'react-redux';
import CurrencyInput from 'react-currency-input-field';

const FormattedNumberField = ({
  label,
  containerClassName,
  percentage = false,
  simple = false,
  currency = false,
  value,
  onChange,
  infoMessage,
  infoMessageClassName,
  autoFormat,
  className,
  id,
  right = false,
  asterisk = false,
  ...rest
}) => {

   const [formattedValue,setFormattedValue] = useState();
   const [realValue,setRealValue] = useState();
   
   const formatNumber = (value) =>{
     //console.log(value)
     if(!isEmpty(value)){
     if(isNaN(value)){
      if(currency){
        setFormattedValue(currencyFormatter(value))
      }else if(percentage){
        setFormattedValue(percentageFormatter(value))
      }else{
        setFormattedValue(value)
      }
      if(value){
       setRealValue(value)
      }
    }else{
      let temp = (value).replaceAll(',','.')
      temp=parseFloat(temp)
      if(currency){
        setFormattedValue(currencyFormatter(temp))
      }else if(percentage){
        setFormattedValue(percentageFormatter(temp))
      }else{
        setFormattedValue(temp)
      }
      if(temp){
       setRealValue(temp)
      }
    }
  }
   }

  //  useEffect(()=>{
  //    //console.log(value)
  //   if(value){
  //     setRealValue((value))
  //   }
  //   if(autoFormat){
  //     setFormattedValue(currencyFormatter((value)))
  //   }else{
  //     setFormattedValue((value))
  //   }

  //   //console.log(value)
    
  //  },[value])

   const checkInput = (v)=>{
     onChange(v.target.value)
     let temp = (v.target.value).replaceAll(',','.')
     //console.log(parseFloat(temp))
     //setFormattedValue(parseFloat(temp))
     value=parseFloat(temp)

   }

   const viewMode =  useSelector(state => state.forms.carrier.viewMode);


  return (
    <div className={containerClassName || ''}>
      <div className="d-flex">
        <Label label={label} asterisk={asterisk}/>
        <InfoMessage
          infoMessage={infoMessage}
          overlayClassName={infoMessageClassName}
        />
      </div>
      {/* <Input
        {...rest}
        onChange={v=> checkInput(v)}
        value={viewMode && formattedValue && !autoFormat ? (isNaN(formattedValue)? currencyFormatter(formattedValue.replaceAll(',','.')):currencyFormatter(parseFloat(formattedValue.replaceAll(',','.')))):formattedValue}
        onBlur={v=> autoFormat == false || isNil(autoFormat) ? formatNumber(v.target.value):''}
        onClick={()=>autoFormat == false || isNil(autoFormat) ? setFormattedValue(realValue):''}
      /> */}
      
      <CurrencyInput className={`ant-input ant-input-lg ${right ? "formattedNumberField" : ""}`}
  id={id}
  name="input-name"
  decimalsLimit={2}
  allowNegativeValue={false}
  decimalScale={2}
  value={value}
  groupSeparator={'.'}
  decimalSeparator={','}
  onValueChange={(value, name) =>onChange(value)}
  suffix={' €'}
  placeholder={rest.placeholder}
  disabled={rest.disabled}
/>

    </div>
  );
};

FormattedNumberField.propTypes = {
  label: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  value: PropTypes.number.isRequired,
  percentage: PropTypes.bool,
  simple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default FormattedNumberField;
